import {
  makeObservable, observable, flow, computed, action,
} from 'mobx';
import { toast } from 'sonner';

import { api } from '@/lib/services';
import { ApiRoutes } from '@/lib/routes';
import { Add } from '@/components/icons/IconMap';

export default class BrowseSegmentsStore {
  loading = false;

  pagination = {};

  query = { search: '', page: 1 };

  segments = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      query: observable,
      segments: observable,
      actions: computed,
      setSearchText: action,
      consume: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get processing() {
    return this.loading;
  }

  get actions() {
    const list = [];
    if (this.parentStore?.parentStore?.authenticationStore?.isAdmin) {
      list.push({
        id: 'inventory:addSegment',
        label: 'New Segment',
        onClick: () => this.parentStore.createSegmentStore.show(),
        icon: Add,
        location: 'primary',
        processing: this.parentStore.createSegmentStore.processing,
        disabled: this.parentStore.createSegmentStore.processing,
      });
    }
    return list;
  }

  setSearchText(search) {
    this.query.search = search;
  }

  consume(segment) {
    const index = this.segments.findIndex((s) => s.id === segment.id);
    if (index !== -1) {
      this.segments.splice(index, 1, segment);
      this.segments = [...this.segments];
    } else {
      this.segments = [segment, ...this.segments];
    }
  }

  * load(query) {
    try {
      this.loading = true;
      this.query = { search: query?.search ?? '', page: query?.page ?? 1 };
      const response = yield api.get(ApiRoutes.forSegments(this.query));

      if (response.status === 200) {
        this.segments = response.data.items;
        this.pagination = {
          page: response.data.page,
          totalItems: response.data.totalItems,
          totalPages: response.data.totalPages,
          pageSize: response.data.pageSize,
        };
        return { success: true, data: response.data };
      }
      throw new Error('Unexpected status code');
    } catch (e) {
      toast.error('Error loading segments', {
        description: e?.response?.data?.message || 'Unexpected error, please try again later.',
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
